import React from "react";
import ArticleSlider from "./ArticleSlider";

import { gql, useQuery } from "@apollo/client";
import { ArticleSliderContainer } from "./ArticleSlider/styles";

const GET_FEATURED_ARTICLES = gql`
  {
    featuredArticles {
      id
      title
      slug
      endpoint
      author {
        fullName
      }
      createdOn
      imageUrl
    }
  }
`;

export default function ArticleGallery() {
  const { loading, error, data } = useQuery(GET_FEATURED_ARTICLES);

  if (loading) return <ArticleSliderContainer />;
  if (error) return <p>Error</p>;

  const articles = data.featuredArticles;

  return <ArticleSlider articles={articles} />;
}
